import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import DropdownList from './dropdown_list.jsx';

const Realize = { Utils: window.UtilsMixin };

@mixin.decorate(window.CssClassMixin)
export default class DropdownButton extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		hover: PropTypes.bool,
		optionsBelowButton: PropTypes.bool,
		gutter: PropTypes.number,
		actions: PropTypes.array,
		itemComponent: PropTypes.func
	};

	static defaultProps = {
		id: Realize.Utils.generateUUID(),
		name: '',
		hover: false,
		optionsBelowButton: false,
		actions: [],
		itemComponent: window.Button
	};

	componentDidMount() {
		this.setDropdownPlugin();
	}

	render() {
		return (
			<div className="dropdown-container">
				<a className="dropdown-button button btn" ref="dropdown" data-activates={this.props.id}>
					<Icon className="material-icons right" type="keyboard_arrow_down"  />
					{this.props.name}
				</a>
				<DropdownList id={this.props.id} actions={this.props.actions} itemComponent={this.props.itemComponent} />
			</div>
		);
	}

	handleDocumentClick() {		
		const $dropdownList = $(`#${this.props.id}`);		

		if ($dropdownList.hasClass('active')) {						
			$dropdownList.removeClass('active');				
		}		
	}

	setDropdownPlugin() {
		var $dropdownNode = $(ReactDOM.findDOMNode(this.refs.dropdown));
		$dropdownNode.dropdown({
			hover: this.props.hover,
			belowOrigin: this.props.optionsBelowButton,
			gutter: !this.props.gutter ? 19.5 : this.props.gutter
		});		

		document.body.addEventListener('touchstart', this.handleDocumentClick.bind(this));
	}
}
